export const versionApi = `https://api-de.dealwise.app/version/component?country=de&h=${+new Date()}`;
